import { SolutionPriceContainer } from '../Types/MatchingProducts';

export const setPricePLP = (
  productListItemElement: HTMLDivElement,
  priceContainer: SolutionPriceContainer | undefined
) => {
  if (!priceContainer || !productListItemElement) return;

  let priceElement = productListItemElement.querySelector('.price-value');
  if (!priceElement) return;

  if (window._THULEDATA?.isExtranet) {
    let rrpElement: HTMLSpanElement = productListItemElement.querySelector('.RRP-value') as HTMLSpanElement;
    rrpElement.innerHTML = priceContainer.PriceFormatted;
    priceElement.innerHTML = '';
  } else {
    let discountPriceElement: HTMLSpanElement = productListItemElement.querySelector(
      '.discount-price-value'
    ) as HTMLSpanElement;
    if (!discountPriceElement) return;

    if (priceContainer.DiscountPrice > 0) {
      priceElement.innerHTML = priceContainer.PriceFormatted;
      discountPriceElement.innerHTML = priceContainer.DiscountPriceFormatted;
      priceElement.classList.add('line-through-text');
    } else {
      priceElement.innerHTML = priceContainer.PriceFormatted;
      discountPriceElement.innerHTML = '';
      priceElement.classList.remove('line-through-text');
    }
  }
};
